<script setup lang="ts">
import { computed } from 'vue';
import { FONT_SIZES } from '@/components/document/sub-components/file-manager/views/file-explorer-view/iconSize';
import type { FileExplorerIconSize } from '@/components/document/sub-components/file-manager/logic/core/useFileManagerSettings';

const props = defineProps<{
  name: string;
  iconSize: FileExplorerIconSize;
  // Optional label override — e.g. the details table shows the extension in its own column, so it
  // passes the extension-stripped name here. When omitted, the full name is shown (grid/list).
  displayName?: string;
}>();

const fontSize = computed(() => FONT_SIZES[props.iconSize]);
</script>

<template>
  <span class="file-object-name" :style="{ fontSize }">{{ displayName ?? name }}</span>
</template>

<style scoped>
.file-object-name {
  word-break: break-word;
}
</style>
